import React from 'react';

export const LegendBetaMiniIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="9"
    height="13"
    viewBox="0 0 8 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.766789 9.874V0.983999C0.766789 0.899999 0.780789 0.857999 0.850789 0.843999C1.34079 0.83 2.71279 0.802 3.70679 0.802C6.68879 0.802 7.17879 2.328 7.17879 3.252C7.17879 4.204 6.67479 4.778 6.32479 5.03C6.84279 5.296 7.62679 5.898 7.62679 7.186C7.62679 8.894 6.14279 10.028 3.73479 10.028C2.37679 10.028 1.38279 10.014 0.864789 10C0.794789 9.986 0.766789 9.944 0.766789 9.874ZM2.67079 6.08V8.376C2.96479 8.39 3.27279 8.404 3.69279 8.404C4.89679 8.418 5.61079 8.026 5.61079 7.214C5.61079 6.738 5.41479 6.332 4.75679 6.164C4.53279 6.108 4.22479 6.08 3.87479 6.08H2.67079ZM2.67079 2.468V4.414H3.62279C4.09879 4.414 4.65879 4.456 4.86879 4.484C5.12079 4.26 5.28879 3.994 5.28879 3.532C5.28879 2.818 4.75679 2.44 3.69279 2.44C3.25879 2.44 2.97879 2.454 2.67079 2.468Z"
      fill={props.fill || '#0265DC'}
    />
  </svg>
);
